import React, { useState, useRef, useEffect } from "react";
import { toast } from "sonner";
import { backend, eventBackend } from "../../services";
import ManShortSelector from "../../components/ui/shortItemSelect";
import { AddUserModalProps, DeleteUserTaskModalProps, EventFullData, UserShortInfo } from "../../types";
import { taskUserStatusNames } from "../../constants";

const TaskDeleteUserModal: React.FC<DeleteUserTaskModalProps> = ({
  task_id,
  user_id,
  onSave,
  closeModal,
}) => {
  const [comment, setComment] = useState<string | undefined>(); // Комментарий
  const modalRef = useRef<HTMLDivElement>(null); // Ref для модального окна

  // Закрытие модального окна с сохранением
  const closeWithSave = () => {
    if (!task_id || !user_id) return;
    if (!comment) {
      toast("Комментарий обязателен");
      return;
    }
    onSave(comment)
    closeModal(); // Закрываем модальное окно
  };

  // Обработчик клика за пределами модального окна
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        modalRef.current &&
        !modalRef.current.contains(event.target as Node)
      ) {
        closeModal(); // Закрываем модальное окно
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [closeModal]);

  return (
    <div className="editModal" ref={modalRef}>
      <div className="modalHeading">
        <h3>Удалить пользователя</h3>
      </div>
      <div className="columnCenter creationForm">
        <div className="formField formRow commentRow">
          <label htmlFor="description">Комментарий</label>
          <textarea
            id="description"
            name="description"
            value={comment}
            onChange={(event) => setComment(event.target.value)}
          />
        </div>
      </div>
      <div className="flex between btnRow">
        <button className="filterButton" type="button" onClick={closeWithSave}>
          Сохранить
        </button>
        <button className="cancelButton" type="button" onClick={closeModal}>
          Отменить
        </button>
      </div>
    </div>
  );
};

export default TaskDeleteUserModal;